import { useState, useEffect } from 'react'
import PouchDB from 'pouchdb'
import { sortBy, compact, flatten } from 'lodash'
import { getMonthDBNamesForCustomer } from '../utils/network'
import { Action } from '../components/machine-action'

/*

This hook fetches the most recent action for one machine for the last three months:

*/

export interface AllDocsResult {
  doc?: PouchDB.Core.ExistingDocument<any & PouchDB.Core.AllDocsMeta> | undefined;
  id: string;
  key: string;
  value: {
    rev: string;
    deleted?: boolean | undefined;
  };
}

export const useMostRecentActions = (
  customerId: string | undefined,
  machineId?: string,
  getOnlyIncompleteActions?: boolean,
  key?: number | string
) => {
  const monthDBs = getMonthDBNamesForCustomer(customerId)
  const [lastActions, setLastActions] = useState<Action[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [hasLoaded, setHasLoaded] = useState(false)
  useEffect(() => {
    setIsLoading(true)
    setHasLoaded(false)
    let didCancel = false
    const fetchData = async () => {
      const allDataByMonth = await Promise.all(
        monthDBs.map(async (monthDBName: any) => {
          const db = new PouchDB(monthDBName, { skip_setup: true })
          try {
            const res = await db.allDocs({
              // We’re specifying the millenium with the 2, that fetches all work orders/actions. I don’t see this app running beyond the year 2999
              startkey: machineId && `ma_${machineId}:2`,
              endkey: machineId && `ma_${machineId}:2\ufff0`,
              include_docs: true
            })
            return res
          } catch (e) {
            return { rows: [] }
          }
        })
      )
      console.log('allDataByMonth', allDataByMonth)
      // map out docs, remove empties, sort by _id, which effectively pre-groups
      // by metric and then by date, newest last
      const allData: any[] = sortBy(compact(flatten(allDataByMonth.map(m => m.rows)).map(m => m.doc)), '_id')

      console.log('allData', allData)

      if (getOnlyIncompleteActions) {
        setLastActions(allData.filter((doc: any): boolean => {
          return doc.done === false
        }))
      } else {
        setLastActions(allData)
      }

      if (!didCancel) {
        setIsLoading(false)
        setHasLoaded(true)
      }
    }
    if (customerId && machineId) {
      fetchData()
    }
    // Clean up on unmount
    return () => {
      didCancel = true
    }
    // only run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, machineId])
  return { lastActions, isLoading, hasLoaded }
}
